<template>
	<div class="content">
		<div class="content_head">
			<p><input type="text" @keypress="pageIndex=1;getData()" placeholder="会员手机号|会员姓名" class="search"
					v-model="searchText" />
				<button type="button" class="button" @click="getData()">查询</button>
			</p>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>订单编号</th>
						<th>客户</th>
						<th>借书数量</th>
						<th>配送人</th>
						<th>运费</th>
						<th>收货地址</th>
						<th>处理店铺</th>
						<th>订单状态</th>
						<th>配书</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in orders">
						<td> 
							{{index+1}}
						</td>
						<td class="red left">
							{{i.OrderDate}}<br />
							{{i.OrderCode}}
							{{i.BookNums+'本'}}
						</td>
						<td style="text-align: left;">
							{{i.CustomerName}}<br />
							{{i.CustomerPhone}}<br />
						<span class="red">{{i.shopName}}</span>	
						</td>
						<td>
							{{i.BookCount +'/'+i.BookNums}}
						</td>
						<td>
							<select v-model="i.TransporterID" style="line-height: 1.5rem;width: 6rem;">
								<option v-for="(j,index) in Transporter" :value="j.UserID">{{j.UserName}}</option>
							</select>
						</td>
						<td>
							应付:<input type="text" v-model="i.FreightMoney"
								style="width:2rem;text-align: right;padding: .3rem .5rem;" />¥
							<br />
							实付:<input type="text" v-model="i.ActualPayment"
								style="width:2rem;text-align: right;padding: .3rem .5rem;" />
							¥
						</td>
						<td>
							<textarea v-model="i.Destination"></textarea>

						</td>
						<td>
							{{i.shopName}}
						</td>
						<td>
							<span class="red">{{i.OrderState==0?"付款":"配书"}}</span>
						</td>
						<td>
							<button type="button" class="button" @click="setOrder(i.CustomerOrderID)"> 订单配书 </button>
							<br />
							<button type="button" class="button" @click="updateOrder(i)"> 更新订单 </button>
							<br />
							<button type="button" class="button"
								:class="{'disabled':i.BookCount !=i.BookNums || i.TransporterID==0}"
								:disabled="i.BookCount !=i.BookNums || i.TransporterID==0"
								@click="customerOrderSend(i)"> 开始配送 </button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>

			<select v-model="pageRows" @change="changePageRows">
				<option value="10">10/页</option>
				<option value="20">20/页</option>
				<option value="30">30/页</option>

			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
		</div>
	</div>


</template>

<script>
	import j from './index.js'
	export default j
</script>

<style>
</style>
